import { Modal } from '@mui/material';
import React, { useState, useEffect, useRef } from 'react';
import Swal from 'sweetalert2';
import request from '../../../Helpers/API';
import { LoaderScreen } from '../../components/LoaderScreen';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckIcon from '@mui/icons-material/Check'; 

export const ModalImagen = ({ open, handleClose, datos, imagenesBD }) => {
    
    const [imagenes, setImagenes] = useState(Array(4).fill(null));
    // const [imagenesExistentes, setImagenesExistentes] = useState([]);
    // const [imagenesNuevas, setImagenesNuevas] = useState([]);
    // const [loader, setLoader] = useState({ mostrar: false, alerta: false, error: false, mensaje: "" });
    const fileInputsRef = useRef([]);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
      });

    // useEffect(() => {
    //     if (open) {
    //         const imagenesProcesadas = imagenesBD.map(img => ({
    //             id_imagen: img.id_imagen,
    //             documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
    //             extension: img.extension || "jpg"
    //         }));

    //         setImagenesExistentes(imagenesProcesadas.slice(0, 4)); 
    //         setImagenesNuevas([]); 
    //     }
    // }, [open, imagenesBD]);

    useEffect(() => {
        if (open) {
            const imagenesProcesadas = imagenesBD.map(img => ({
                id_imagen: img.id_imagen,
                documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
                extension: img.extension || "jpg",
                nueva: false
            }));

            setImagenes([...imagenesProcesadas, ...Array(4 - imagenesProcesadas.length).fill(null)]);
        }
    }, [open, imagenesBD]);

    const abrirSelector = (index) => fileInputsRef.current[index]?.click();

    // const GetFile = (event, index) => {
    //     const file = event.target.files[0];
    //     if (!file) return;

    //     const formatosValidos = ["jpg", "jpeg", "png"];
    //     const extension = file.name.split(".").pop().toLowerCase();

    //     if (!formatosValidos.includes(extension)) {
    //         Swal.fire("Clientes", "Formato de archivo no válido", "error");
    //         event.target.value = "";
    //         return;
    //     }

    //     const fReader = new FileReader();
    //     fReader.readAsDataURL(file);
    //     fReader.onloadend = function (event) {
    //         const nuevaImagen = { documento: event.target.result, extension };
    //         setImagenesNuevas((prev) => [...prev, nuevaImagen]);
    //         onGuardar(nuevaImagen);
    //     };
    // };

    const GetFile = (event, index) => {
        const file = event.target.files[0];
        if (!file) return;

        const formatosValidos = ["jpg", "jpeg", "png"];
        const extension = file.name.split(".").pop().toLowerCase();

        if (!formatosValidos.includes(extension)) {
            Swal.fire("Clientes", "Formato de archivo no válido", "error");
            event.target.value = "";
            return;
        }

        const fReader = new FileReader();
        fReader.readAsDataURL(file);
        fReader.onloadend = function (event) {
            const nuevaImagen = { documento: event.target.result, extension, nueva: true };
            setImagenes((prev) => {
                const nuevasImagenes = [...prev];
                nuevasImagenes[index] = nuevaImagen;
                return nuevasImagenes;
            });
        };
    };

    const onEliminarImagen = async (index) => {
        const imagen = imagenes[index];

        if (!imagen.nueva) {
            const confirmacion = await Swal.fire({
                title: '¿Eliminar imagen?',
                text: "Esta acción no se puede deshacer",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
            });

            if (!confirmacion.isConfirmed) return;

            try {
                await request.get(`ImagenesMaquinaria/EliminarImagenes?id_imagen=${imagen.id_imagen}`);
                Swal.fire("Éxito", "Imagen eliminada correctamente", "success");
            } catch (error) {
                Swal.fire("Error", "No se pudo eliminar la imagen", "error");
                return;
            }
        }

        setImagenes((prev) => {
            const nuevasImagenes = [...prev];
            nuevasImagenes[index] = null;
            return nuevasImagenes;
        });
    };

    // const onEliminarImagen = async (id_imagen, index) => {
    //     const confirmacion = await Swal.fire({
    //         title: '¿Estás seguro de eliminar esta imagen?',
    //         text: "Esta acción no se puede deshacer",
    //         icon: 'warning',
    //         showCancelButton: true,
    //         confirmButtonText: 'Sí, eliminar',
    //         cancelButtonText: 'Cancelar',
    //     });
    
    //     if (confirmacion.isConfirmed) {
    //         setLoader({ ...loader, mostrar: true });
    //         try {
    //             await request.get(`ImagenesMaquinaria/EliminarImagenes?id_imagen=${id_imagen}`);
                
    //             setImagenesExistentes((prevImagenes) => prevImagenes.filter((_, i) => i !== index));

    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("Eliminación exitosa", "Imagen eliminada correctamente", "success");
    //         } catch (error) {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("Error", "No se pudo eliminar la imagen", "error");
    //         }
    //     } else {
    //         setLoader({ ...loader, mostrar: false });
    //     }
    // };

    // const onGuardar = (imagen) => {
    //     if (!imagen) return;
    //     setLoader({ ...loader, mostrar: true });
        
    //     const imagenPost = { documento: imagen.documento, extension: imagen.extension, idinventario: datos.idinventario };
    //     request.post("ImagenesMaquinaria/GuardarImagenes", imagenPost)
    //         .then((result) => {
    //             setLoader({ ...loader, mostrar: false });
    //             // console.log(result)
    //             const imagenesProcesadas = result.map(img => ({
    //                 id_imagen: img.id_imagen,
    //                 documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
    //                 extension: img.extension || "jpg"
    //             }));

    //             setImagenesExistentes([]);
    //             setImagenesExistentes(imagenesProcesadas);
    //             Swal.fire("CARGA DE IMÁGENES", "Imagen guardada con éxito", "success");
    //         })
    //         .catch((error) => {
    //             setLoader({ ...loader, mostrar: false });
    //             Swal.fire("CARGA DE IMÁGENES", JSON.stringify(error), "error");
    //         });
    // };

    const onGuardar = async (imagen) => {
        if (!imagen || !imagen.nueva) return;
        const imagenPost = { documento: imagen.documento, extension: imagen.extension, idinventario: datos.idinventario };
        return request.post("ImagenesMaquinaria/GuardarImagenes", imagenPost);
    };

    const handleGuardar = async () => {
        const nuevasImagenes = imagenes.filter(img => img && img.nueva);
        if (nuevasImagenes.length === 0) {
            Swal.fire("Aviso", "No hay imágenes nuevas para guardar", "info");
            return;
        }
        setLoader({ ...loader, mostrar: true });
        try {
            const results = await Promise.all(nuevasImagenes.map(img => onGuardar(img)));

            const imagenesProcesadas = results.flat().map(img => ({
                id_imagen: img.id_imagen,
                documento: img.documento.startsWith("data:image") ? img.documento : `data:image/${img.extension};base64,${img.documento}`,
                extension: img.extension || "jpg",
                nueva: false
            }));

            setImagenes([...imagenesProcesadas, ...Array(Math.max(0, 4 - imagenesProcesadas.length)).fill(null)]);
            setLoader({ ...loader, mostrar: false });
            Swal.fire("Éxito", "Imágenes guardadas correctamente", "success");
            
            handleClose();
        } catch (error) {
            // console.log(error)
            Swal.fire("Error", "No se pudieron guardar las imágenes", "error");
            setLoader({ ...loader, mostrar: false });
        }
    };

    return (
        <Modal open={open}>
            <div className="imagen-modal">
                <LoaderScreen loader={loader} />
                <div className="imagen-modal-title">
                    <h3>IMÁGENES DE MODELO: {datos !== null ? datos.modelo_descripcion : ""}</h3>
                    <button className="guardar-button" onClick={handleGuardar}><CheckIcon /></button>
                    <button className="cerrar-button" onClick={handleClose}>X</button>
                </div>
                <div className="imagen-modal-soy-el-titulo-line">
                    <div className="imagen-modal-soy-el-titulo-line-bl"></div>
                    <div className="imagen-modal-soy-el-titulo-line-circle"></div>
                    <div className="imagen-modal-soy-el-titulo-line-br"></div>
                </div>
                <div className="contenedor-cuadrados">
                    {imagenes.map((img, index) => (
                        <div key={index} className="cuadrado-imagen" onClick={() => !img && abrirSelector(index)}>
                            {img ? (
                                <>
                                    <img src={img.documento} alt={`imagen-${index}`} className="imagen-previa" />
                                    <DeleteIcon className="icono-eliminar" onClick={() => onEliminarImagen(index)} />
                                </>
                            ) : (
                                <AddPhotoAlternateIcon className="icono-agregar" />
                            )}
                            <input
                                type="file"
                                accept="image/*"
                                style={{ display: "none" }}
                                ref={(el) => (fileInputsRef.current[index] = el)}
                                onChange={(e) => GetFile(e, index)}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Modal>
    );
};
